export const API_URL = process.env.REACT_APP_CORE_API_URL;
export const LEAFLET_ACCESS_TOKEN = 'pk.eyJ1IjoidW5pbWV0cmljcyIsImEiOiJjbTM1bWJpMDIwY2dlMmxzOTRwNmVod2Q5In0.Oo2rbhN-NhulQLzsHfP7Ow';
